import { render } from "./FoodMatchingGame.vue?vue&type=template&id=a61915b6&scoped=true"
import script from "./FoodMatchingGame.vue?vue&type=script&lang=js"
export * from "./FoodMatchingGame.vue?vue&type=script&lang=js"

import "./FoodMatchingGame.vue?vue&type=style&index=0&id=a61915b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a61915b6"]])

export default __exports__